import React from 'react';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { ManageServicesCreate } from '@components/templates/myAccount/manageServicesCreate';

export function ManageServicesCreatePage() {
    const { t } = useTranslation();

    const translations = {
        title: t('manage-services-create-component.metatags.title'),
        description: t('manage-services-create-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myServicesCreate,
        index: false,
    });

    return <ManageServicesCreate />;
}
